import { Component, Input } from "@angular/core";
import { NgIf } from "@angular/common";

@Component({
  selector: "validation-message",
  templateUrl: "./validation-message.html",
  standalone: true,
  imports: [NgIf]
})
export class ValidationMessageComponent {
  @Input() name: string;
  show: boolean = false;

  showsErrorIncludedIn(errors: string[]): boolean {
    return errors.some((error) => error === this.name);
  }
}
